import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const GpsTaikiJokyoKbn = props => {
  return <Dropdown.Static kubunKey='gps_taiki_jokyo_kbn' {...props} />
}
